// Título de sección del contenido principal: mayúsculas, azul marino, con
// una línea horizontal que se extiende hasta el final del contenedor.
export default function SectionTitle({ children }) {
  return <h2 className="cv-section-title">{children}</h2>;
}
